import React, { useEffect, useState } from 'react';
import './HomePage.scss';
import { useGetAllServiceDataQuery } from '../../../Services/vehicle/Vehicle';
import { useNavigate } from 'react-router-dom';
import { getTenantSubdomain, isAutoServicesTenant } from '../../../utils/tenantBranding';


interface IPROPS {
  setIsCartOpen:any
  setCurrentStep:any
  setOpenVehicleModal:any
  setOpenModal:any
  vehicleData:any
}

const ServicePage: React.FC<IPROPS> = ({setIsCartOpen, setCurrentStep, setOpenVehicleModal,setOpenModal, vehicleData}) => {
  const [services, setServices] = useState([]);
  const { data: serviceData } = useGetAllServiceDataQuery({});
  const [showAll, setShowAll] = useState(false);

  const navigate = useNavigate();
  const fetchingTenant = getTenantSubdomain();
  const autoServicesBranding = isAutoServicesTenant(fetchingTenant);

  useEffect(() => {
    if (serviceData) {
      setServices(serviceData);
    }
  }, [serviceData]);

  // Show only the first 3 or all based on state
  const displayedServices = showAll ? services : services?.slice(0, 4);


  const token = localStorage.getItem("customer-token");



  const bookingHandler = () => {
    if (!token) {
      setOpenModal("login");
      return;
    }
    if (token && vehicleData.length === 0) {
      setOpenVehicleModal(true);
      return;
    }
    navigate("/vehicle/select");
  };

  const navigateHandler = () => {
    navigate("/customer/services");
  };

  return (
    <div className="eurorepar-container">
      <h1>{autoServicesBranding ? "AUTO SERVICES" : "EUROREPAR SERVICES"}</h1>
      <h3>More Than Repairs — It’s Car Care You Can Count On</h3>

      <div className="services-grid">
        {displayedServices?.map((service, index) => (
          <div key={index} className="service-card">
            <img src={service.image} alt={service.title} />
            <h4>{service.name}</h4>
            <p style={{color: "#37170A"}}></p>
            <button 
           

            onClick={bookingHandler}
            >Book Now</button>
          </div>
        ))}
      </div>

      {services?.length > 4 && (
        <button className="view-all-btn" onClick={navigateHandler}>
          {showAll ? 'View Less' : 'View All'}
        </button>
      )}
    </div>
  );
};

export default ServicePage;